module.exports = __webpack_public_path__ + "static/media/tissue.209070a7.svg";